import React, {useState, useEffect, useRef} from 'react';
import { Table } from 'antd';
import { Link, Redirect, useHistory } from 'react-router-dom';
import { Button, Menu, Dropdown, Skeleton, DatePicker, Modal, Form, Input, Col, Row, message, Popconfirm } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
// import Header from '../../Components/Header';
// import { Redirect } from 'react-router-dom';
import moment from 'moment';
// import { is_user_loggedin, get_user } from '../../Utils/auth';
import { useFirestore } from 'reactfire';
import Appointments from './Appointments';
import Sidebar from '../Sidebar';
import Loader from '../../Components/Loader';
import { useUser, useAuth } from 'reactfire';
// import { useMemo } from 'reactn';
import Barcode from 'react-barcode';
import BarcodeReader from 'react-barcode-reader';
import firebase from 'firebase';
import dateDifferenceUsingMoment from '../../Utils/util';

const Patients = () => {

  const [guestUser, setGuestUser] = useState(false);

  const { RangePicker } = DatePicker;
  const auth = useAuth();
  
  const histry = useHistory();

  const { Search } = Input;

  const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};
const tailLayout = {
  wrapperCol: { offset: 0, span: 24 },
};
  const [patients, setPatients] = useState({list: []});
  const [appointModal, setAppointmentModal] = useState(false);
  const [viewappointModal, setViewAppointmentModal] = useState(false);
  const [viewPatientID, setViewPatientID] = useState(false);
  const [printID, setPrintID] = useState({});
  
  const [viewPatientModal, setviewPatientModal] = useState(false);
  const [patientInfo, setPatientInfo] = useState({});
  const [viewTodayAppointment, setViewTodayAppointments] = useState(false);
  const [viewAllAppointment, setViewAllAppointments] = useState(false);
  
  const [appointmentState, setAppointmentState] = useState({});
  const [appointments, setAppointments] = useState([]);
  const [AllAppointments, setAllAppointments] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [useID, setUserID] = useState();
  const [form] = Form.useForm();
  const [token, setToken] = useState(1);
  const firestore = useFirestore();
  const query = firestore.collection("patients");
  const [count, setCount] = useState(1);

  const [state, setState] = useState({
    searchText: '',
    searchedColumn: '',
  })


  const searchInput = useRef(null);
  
    useEffect(()=> {
        getPatients();
        // getTodaysAppointments();

        if (count < 2 ) {
          getTodaysAppointments();
          // getAllAppointments();
          auth.onAuthStateChanged(user => {
            if(user) {
              setGuestUser(false);
            } else {
              setGuestUser(true);
            }
          })
        }

        form.setFieldsValue({
          date: moment(),
        });
    }, [appointmentState, count]);

    const getPatients = () => {
      setLoading(true);
      let records = [];
      query.orderBy('date', 'desc').limit(10).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            records.push({data: doc.data(), id: doc.id});
        });
        setPatients({list : records});
        setLoading(false);
      }).catch(() => {
        message.error('You are Offline');
      });

    }

    const cancelAppointmentModal = () => {
      setAppointmentModal(false);
    }

    const closeDeleteModal = () => {
      setDeletePopup(false);
    }

    const viewPatientinfoModal = (patientInfo) => {
      setviewPatientModal(true);
      setPatientInfo(patientInfo.data);
      console.log(patientInfo);
    }

    const cancelviewPatientModal = () => {
      setviewPatientModal(false);
    }
    
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
      });
    };
  
    const handleReset = clearFilters => {
      clearFilters();
      setState({ searchText: '' });
    };
    // ===========
  

    const deletePatient = (id) => {
      setDeletePopup(true);
      setUserID(id.id);
    }

    const handleDeletePatient = () => {
      query.doc(useID).delete().then((response) => {
        closeDeleteModal();
        getPatients();
      })
    }

    const toCamelCase = ([first, ...rest]) => {
      const [head, ...tail] = rest.join('').split(/-|_/)
        .map(([head, ...tail]) => 
          [
            head.toUpperCase(),
            tail.join('').toLowerCase()
          ].join(''))
        .join('')
      return [first, head.toLowerCase(), ...tail].join('')
    }

    const isNumeric = (str) => {
      if (typeof str != "string") return false // we only process strings!  
      return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
             !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    const searchPatients =(value) => {
      let searchBase = 'contactNumber';
      let p_name = '';

      p_name = value && toCamelCase(value);


      if (isNumeric(value)) {
        searchBase = 'contactNumber';
        p_name = value
      } else {
        searchBase = 'fullName';
      }


      setLoading(true);
        if (value.length === 0) {
          getPatients(); 
        } else {
          let records = [];
          query.where(searchBase, "==", value).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
            setPatients({list : records});
            setLoading(false);
          });
        }
    }

    const printIDModal = (patient) => {
      setViewPatientID(true);
      setPrintID(patient);
      console.log(patient);
    }

    const menu = (patient) => (
      <Menu>
        <Menu.Item key={Math.random()} onClick={() => printIDModal(patient)}>Print ID</Menu.Item>
        <Menu.Item key={Math.random()}><Link to={`/edit_patient/${patient.id}`}>Update</Link></Menu.Item>
        <Menu.Item key={Math.random()} onClick={() => viewPatientinfoModal(patient)}> View Patient Info</Menu.Item>
        {/* <Menu.Item key={Math.random()}><Link to={`/appointment_hisotry/${patient.id}`}>Appointment History</Link></Menu.Item> */}
        {auth.currentUser && auth.currentUser.email !== 'rep_user@gmail.com' && <Menu.Item key={Math.random()} onClick={() => deletePatient(patient)}> Delete </Menu.Item>}
      </Menu>
    );

    const handleAppointment = (patient) => {
      setAppointmentState({
        ...appointmentState,
        patient: patient.id,
        Name: patient.data.fullName
      });
      setUpdateToken();
      setAppointmentModal(true);
    }

    const PatientColumns = [
      {
        title: 'Name',
        dataIndex: patients.list.data && patients.list.data.fullName,
        key: Math.random(),
        render: (text) => text.data.fullName,
      },
      {
        title: 'Phone',
        dataIndex: patients.list.data && patients.list.data.contactNumber,
        key: Math.random(),
        render: (text) => text.data.contactNumber,
      },
      {
        title: 'Gender',
        dataIndex: patients.list.data && patients.list.data.contactNumber,
        key: Math.random(),
        render: (text) =>  text.data.gender,
      },
      {
        title: 'Age',
        key: Math.random(),
        render: (patient) =>  dateDifferenceUsingMoment(patient.data.DOB,new Date()) ,
      },
      {
        title: 'Guardian Name',
        dataIndex: patients.list.data && patients.list.data.guardianName,
        key: Math.random(),
        responsive: ['md'],
        render: (text) => text.data.guardianName,

      },
      {
        title: 'Address',
        dataIndex: patients.list.data && patients.list.data.address,
        key: Math.random(),
        responsive: ['md'],
        render: (text) => text.data.address,
      },
      {
        title: 'Actions',
        key: Math.random(),
        render: (_id) => <Dropdown.Button onClick={() => handleAppointment(_id)} overlay={menu(_id)}>
        Set Appointment
      </Dropdown.Button>
      }
  ];

  const setUpdateToken = () => {
  }

  const setAnAppointment = (values) => {
    setLoadingBtn(true);
    firestore.collection('appointments').add({
      patient: firestore.collection("patients").doc(appointmentState.patient),
      patient_id: appointmentState.patient,
      date: values.date.toDate(),
      date_string: values.date.toString(),
      ticketNumber: parseInt(values.TicketNumber),
      note: values.note ? values.note : '',
      token: token,
      status: 'awaiting'
    }).then(() => {
        setAppointmentModal(false);
        getTodaysAppointments();
        setLoadingBtn(false);
        setViewAppointmentModal(true);

        setTimeout(function() {
          window.focus();
          window.print();
        }, 4000);
      });
  }

  const onFinishFailed = (values) => {
    console.log(values);
  }


  const getTodaysAppointments = () => {
    let records = []
    const date_options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    let currentDate = new Date().toLocaleDateString('en-US', date_options).toString();
    // firestore.collection("appointments").orderBy('date').startAt(currentDate).endAt(currentDate).get().then((querySnapshot) => {
    firestore.collection("appointments").orderBy('date').startAt(new Date(currentDate)).endAt(new Date(currentDate)+"\uf8ff").get().then((querySnapshot) => {

      querySnapshot.forEach((doc) => {
        let dumobj = {};
  
          doc.data().patient.get().then((pt) => {
            dumobj.patient  = pt && pt.data() && pt.data();
            if (dumobj.patient) {
              dumobj.patient.id = pt && pt.id;
            }
          })
          dumobj.date = doc.data().date_string;
          dumobj.note = doc.data().note;
          dumobj.status = doc.data().status;
          dumobj.token = doc.data().token;
          dumobj.ticketNumber = doc.data().ticketNumber;
          dumobj.id = doc.id;
          records.push(dumobj);
        });

    }).finally(() => {
      setToken(records.length + 1);
      setAppointments(records);
      let dumcount = count;
      setCount(++dumcount);
    })


  }

  const viewApointmentsToday = () => {
    setViewTodayAppointments(true);
  }

  const viewAllAppointments = () => {
    setViewAllAppointments(true);
  }

  const deleteAppointment = (id) => {
    console.log(id);
    const appointment_query = firestore.collection("appointments");
    const chiefComplain_query = firestore.collection("ChiefComplaints");
    const vitals_query = firestore.collection("vitals_records");
    const examiniation_query = firestore.collection("Examination");
    const diagnosis_query = firestore.collection("Diagnosis_records");
    const investigation_query = firestore.collection("Invesigation_records");
    const treatment_query = firestore.collection("Treatment_records");



    appointment_query.doc(id).delete().then(() => {
      cancelViewTodayAppointment();
      message.success("Appointment deleted successfully");
      getTodaysAppointments();
    })

    chiefComplain_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        chiefComplain_query.doc(doc.id).delete().then(() => {

          message.success("chiefcomplain deleted of this appointment");
        }

        ) 
      })
    })

    vitals_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        vitals_query.doc(doc.id).delete().then(() => {

          message.success("vitals deleted of this appointment");
        }

        ) 
      })
    })

    examiniation_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        examiniation_query.doc(doc.id).delete().then(() => {

          message.success("Examiniation deleted of this appointment");
        }

        ) 
      })
    })
    diagnosis_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        diagnosis_query.doc(doc.id).delete().then(() => {

          message.success("Diagnosis deleted of this appointment");
        }

        ) 
      })
    })
    investigation_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        investigation_query.doc(doc.id).delete().then(() => {

          message.success("Investigation deleted of this appointment");
        }

        ) 
      })
    })
    treatment_query.where("appointment_id", "==", id).get().then((querySnapshot) => {
      querySnapshot.forEach(doc => {
        treatment_query.doc(doc.id).delete().then(() => {

          message.success("Treatment deleted of this appointment");
        }

        ) 
      })
    })

  }


  const date_options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true};
  const columns = [
    {
      title: '#',
      dataIndex: 'token',
      key: 'token',
      // render: (res) => res && res.token,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (res) => res && new Date(res).toLocaleDateString('en-US', date_options),

    },
    {
        title: 'Name',
        dataIndex: 'patient',
        key: 'patient',
        render: (res) => res && res.fullName,
    },
    {
        title: 'Contact Number',
        dataIndex: 'patient',
        key: 'patient',
        render: (res) => res && res.contactNumber,
    },
    {
      title: 'Ticket Number',
      dataIndex: 'ticketNumber',
      key: 'ticketNumber',
      // render: (res) => res && res.token,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        filters: [
          {
            text: 'attending',
            value: 'attending',
          },
          {
            text: 'awaiting',
            value: 'awaiting',
          },
          {
            text: 'pending',
            value: 'pending',
          },
          {
            text: 'close',
            value: 'close',
          },
        ],

        onFilter: (value, record) => record.status.indexOf(value) === 0,
        sorter: (a, b) => a.status.length - b.status.length,
        sortDirections: ['descend'],
        // render: (res) => res && res.status,
    },
    
    {
        title: 'Actions',
        key: Math.random(),
        render: (item) => <>
            {auth.currentUser && auth.currentUser.email !== 'rep_user@gmail.com' && <Link to={`/attending_patient/${item.patient && item.patient.id}/${item && item.id}`}>Attend</Link>}
            <Popconfirm placement="topRight" title={'Are you really want to Delete this appointment.'} onConfirm={() => deleteAppointment(item.id)} okText="Yes" cancelText="No">
              <span style={{color: "#168eea", paddingLeft: "10px", cursor: 'pointer'}}>Delete</span>
            </Popconfirm>
        </>
      }
  ];

  const cancelViewTodayAppointment = () => {
    setViewTodayAppointments(false);
  }

  const cancelViewAllAppointment = () => {
    setViewAllAppointments(false);
  }


  // get All Appointment Data
  const getAllAppointments = (startD, endD) => {
    let records = [];
    const date_options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    let start = startD.toLocaleDateString('en-US', date_options).toString();
    let end = endD.toLocaleDateString('en-US', date_options).toString();
    
    console.log(end);
    setLoading(true);
    firestore.collection("appointments").orderBy('date').startAt(new Date(start)).endAt(new Date(end)+"\uf8ff").get().then((querySnapshot) => {
        // let index = 0;
        // querySnapshot.forEach((doc) => {
        //     ++ index;
        //     records.push({record: doc.data(), key: doc.id, numbers: index});
        // });

        querySnapshot.forEach((doc) => {
            let dumobj = {};
      
              doc.data().patient.get().then((pt) => {
                dumobj.patient  = pt && pt.data() && pt.data();
                if (dumobj.patient) {
                  dumobj.patient.id = pt && pt.id;
                  
                }
              }).finally(() => {
                let dumcount = count;
                setCount(++dumcount);
              })
              dumobj.date = doc.data().date_string;
              dumobj.note = doc.data().note;
              dumobj.status = doc.data().status;
              dumobj.token = doc.data().token;
              dumobj.ticketNumber = doc.data().ticketNumber;
              dumobj.id = doc.id;
              records.push(dumobj);
            });
    
    }).finally(() => {
      setAllAppointments(records);
      let dumcount = count;
      setCount(++dumcount);
        
    })
}

const changeDateRange = (date) => {
  // setdateRange({
  //   startDate: new Date(date[0]),
  //   endDate: new Date(date[1])
  // });
  getAllAppointments(new Date(date[0]), new Date(date[1]));
}

const handleBarcodeError = (data) => {
  console.log('Error is ',data);
}


const handleBarcodeScane = (data) => {
  if (auth.currentUser && auth.currentUser.email === 'rep_user@gmail.com') {
    setLoading(true);
    let records = [];
    query.where(firebase.firestore.FieldPath.documentId(), "==", data).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
          records.push({data: doc.data(), id: doc.id});
      });
      setPatients({list : records});
      setLoading(false);
    });
  } else {
    let obj = appointments.find(o => o.patient.id === data);
    if (obj) {
      histry.push(`/attending_patient/${obj.patient.id}/${obj.id}`);
    } else {
      setLoading(true);
      let records = [];
      query.where(firebase.firestore.FieldPath.documentId(), "==", data).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            records.push({data: doc.data(), id: doc.id});
        });
        setPatients({list : records});
        setLoading(false);
      });
    }
  }       
}



// const printThis = () => {

//   return true;
// };

    return (
        <React.Fragment>

<BarcodeReader
          onError={handleBarcodeError}
          onScan={handleBarcodeScane}
          />


         {guestUser && <Redirect to="/login"></Redirect>}


      

          <Sidebar showTodayAppointments={true}  showAllAppointments= {true} onViewTodayAppointments={viewApointmentsToday}  onViewAllAppointments={viewAllAppointments}/>

          {loading ? <Skeleton active /> : 
          <React.Fragment>

          {/* {!is_user_loggedin() ? <Redirect to="/login" /> : ''  } */}
            {/* <Header /> */}

        <div className='container'>

          <h3 className="title">Upcoming Appointments:</h3>


          <div className="appointments_top">
           {appointments.length === 0 ? <h3>No Today's Appointments Yet</h3> : 

           <ul>
               {appointments && appointments.map((item) => {
                return (
                  item.status === "awaiting" && 
                <li key={item && item.id}>
                    <Link to={ auth.currentUser && auth.currentUser.email !== 'rep_user@gmail.com' ?  `/attending_patient/${item.patient && item.patient.id}/${item && item.id}` : '/'}>
                        <h4>{item.ticketNumber}</h4>
                        <h5>{item.patient && item.patient.fullName} <span>{item.patient && item.patient.contactNumber}</span></h5>
                        {auth.currentUser && auth.currentUser.email !== 'rep_user@gmail.com' && <button className='btn attend'>Attend</button>}
                    </Link>
                </li>)
               })}
           </ul>
           
            }
        </div>


        {/* <Appointments appointmentsList={appointments && appointments} /> */}

        <Row style={{marginBottom: '20px'}}>
          <Col span={8} offset={8}>
            <Search placeholder="Please enter Full Name or Exact Phone Number to Search" onSearch={searchPatients} enterButton />
          </Col>
        </Row>

          <Table columns={PatientColumns} pagination={false} dataSource={patients.list} />

        </div>

        <Modal
          title="Set Appointment"
          visible={appointModal}
          onCancel={cancelAppointmentModal}
          footer={null}
        >
          <Form
            {...layout}
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            onFinish={setAnAppointment}
            onFinishFailed={onFinishFailed}
            >
            <Form.Item name="date" label="Appointment Date"  rules = {[{ type: 'object', required: true, message: 'Please select time!' }]}>
              <DatePicker showTime size="large" {...tailLayout} />
            </Form.Item>

            <Form.Item
                label="Ticket Number"
                name="TicketNumber"
                rules = {[{required: true, message: 'Please select Ticket Number!' }]}
            >
                <Input type="Number" />
            </Form.Item>

            <Form.Item
                label="Note"
                name="note"
            >
                <Input size="large" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" loading={loadingBtn} htmlType="submit">
                Submit
                </Button>
            </Form.Item>
            
          </Form>
        </Modal>

        <Modal
          title="View Appointment Token"
          visible={viewappointModal}
          onCancel={() => setViewAppointmentModal(false)}
          footer={null}
        >

          <div className="viewAppntmentTkn">
              <h1>{form.getFieldValue().TicketNumber}</h1>
              <h2>{appointmentState.Name}</h2>
              <h2><Barcode value={appointmentState.patient} height={20} width={1} fontSize={12} /></h2>
          </div>
        </Modal>

        <Modal
          title="View Patient ID"
          visible={viewPatientID}
          onCancel={() => setViewPatientID(false)}
          footer={null}
        >
          <div className="viewAppntmentTknID">
              <h2>{printID?.data?.fullName}</h2>
              <h2><Barcode value={printID?.id} height={25} width={1.25} fontSize={16} /></h2>
          </div>
        </Modal>

        <Modal
          title="Today's Appointments"
          visible={viewTodayAppointment}
          onCancel={cancelViewTodayAppointment}
          footer={null}
          width='60%'
        >
          <Table columns={columns} dataSource={appointments} />


        </Modal>

        <Modal
          title="All Appointments"
          visible={viewAllAppointment}
          onCancel={cancelViewAllAppointment}
          footer={null}
          width='60%'
        >

          <p>Please Select Date Range</p>
          <RangePicker  onChange={changeDateRange}/>
          <Table columns={columns} dataSource={AllAppointments} />


        </Modal>


        <Modal
          title="Delete Patient?"
          visible={deletePopup}
          onCancel={closeDeleteModal}
          footer={null}
        >
        <p>Are you Sure you want to Delete this patient?</p>
        <Button>Cancel</Button>
        <Button onClick={handleDeletePatient} type="primary">Delete</Button>



        </Modal>

        <Modal
                    title="Patient's Full Information"
                    visible={viewPatientModal}
                    onCancel={cancelviewPatientModal}
                    footer={null}
                    >

                        <ul className='PatientDetailInfo'>
                            <li><strong>Patient Name: </strong> {patientInfo && patientInfo.fullName}</li>
                            <li><strong>Contact Number: </strong>{patientInfo && patientInfo.contactNumber}</li>
                            {patientInfo && patientInfo.DOB && <li><strong>Age: </strong>{dateDifferenceUsingMoment(patientInfo && patientInfo.DOB,new Date())}</li>}
                            {patientInfo && patientInfo.gender && <li><strong>Gender: </strong>{patientInfo.gender}</li>}
                            {patientInfo && patientInfo.guardianName && <li><strong>Guardian Name: </strong>{patientInfo.guardianName}</li>}
                            {patientInfo && patientInfo.education && <li><strong>Education: </strong>{patientInfo.education}</li>}
                            {patientInfo && patientInfo.occupation && <li><strong>Occupation: </strong>{Array.isArray(patientInfo.occupation) ?  patientInfo.occupation.join(', ') : patientInfo.occupation}</li>}
                            {patientInfo && patientInfo.nationality && <li><strong>Nationality: </strong>{patientInfo.nationality}</li>} 
                            {patientInfo && patientInfo.address && <li><strong>Address: </strong>{patientInfo.address}</li>}
                            {patientInfo && patientInfo.MedicalHistory && <li><strong>Medical History: </strong>{patientInfo.MedicalHistory.join(', ')}</li>}
                            {patientInfo && patientInfo.PastSugicalHistory && <li><strong>Past Sugical History: </strong>{patientInfo.PastSugicalHistory.join(', ')}</li>}
                            {patientInfo && patientInfo.PersonalHistory && <li><strong>Personal History: </strong>{patientInfo.PersonalHistory.join(', ')}</li>}
                            {patientInfo && patientInfo.AddictionHistory && <li><strong>Addiction History: </strong>{patientInfo.AddictionHistory.join(', ')}</li>}
                            {patientInfo && patientInfo.HistoryofanyDrugAllergy && <li><strong>History of any Drug Allergy: </strong>{patientInfo.HistoryofanyDrugAllergy.join(', ')}</li>}
                            {patientInfo && patientInfo.FamilyHistory && <li><strong>Family History: </strong>{patientInfo.FamilyHistory.join(', ')}</li>}
                            
                            {patientInfo && patientInfo.note && <li><strong>Note: </strong>{patientInfo.note}</li>}
                            
                        </ul>
                </Modal>
        </React.Fragment>}

        </React.Fragment>
    );
}

export default Patients;
